// import { useState, useEffect } from 'react';
// import '../styles/products.scss';
// import Card from 'react-bootstrap/Card';
// import Banner1 from '../assets/banner/banner6.webp';
// import Banner2 from '../assets/banner/banner7.webp';
// import Banner3 from '../assets/banner/banner8.jpg';
// import { Link, useNavigate } from 'react-router-dom';

// const CallToAction = () => {
//   const navigate = useNavigate();
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userRole, setUserRole] = useState(null);
//   const [currentMode, setCurrentMode] = useState('custom');

//   useEffect(() => {
//     const token = localStorage.getItem('access_token');
//     const role = localStorage.getItem('role');
//     const savedMode = localStorage.getItem('user_mode') || 'custom';

//     setIsLoggedIn(!!token);
//     setUserRole(role);
//     setCurrentMode(savedMode);
//   }, []);

//   const handleCTAClick = (type) => {
//     // Artisan join should always go directly
//     if (type === 'contact') {
//       navigate('/artisan-join');
//       return;
//     }

//     // Other actions require login
//     if (!isLoggedIn) {
//       navigate('/login', { state: { from: type } });
//       return;
//     }

//     if (type === 'custom') {
//       if (userRole === 'client') {
//         navigate('/client-dashboard');
//       } else if (userRole === 'artisan') {
//         navigate('/artisan-dashboard');
//       } else {
//         navigate('/login');
//       }
//     } else if (type === 'ready-made') {
//       navigate('/ready-made-products');
//     }
//   };

//   const ctaCards = [
//     {
//       image: Banner1,
//       title: 'Custom Furniture Design',
//       description:
//         'Bring your unique vision to life with personalized designs crafted just for you',
//       buttonText: 'Start Custom Project',
//       buttonIcon: '🎨',
//       type: 'custom',
//       features: [
//         'Personalized Design',
//         'Premium Materials',
//         'Expert Craftsmanship',
//       ],
//       buttonPosition: 'bottom',
//     },
//     {
//       image: Banner2,
//       title: 'Ready-Made Collection',
//       description:
//         'Shop premium furniture available for immediate delivery. Quality pieces, ready when you are.',
//       buttonText: 'Browse Collection',
//       buttonIcon: '🛍️',
//       type: 'ready-made',
//       features: ['In Stock', 'Fast Delivery', 'Quality Guaranteed'],
//       buttonPosition: 'bottom',
//     },
//     {
//       image: Banner3,
//       title: 'For Artisans & Makers',
//       description:
//         'Join our community of skilled artisans and showcase your work to thousands of customers',
//       buttonIcon: '🎨',
//       type: 'contact',
//       features: [
//         'Showcase Your Work',
//         'Connect with Clients',
//         'Grow Your Business',
//       ],
//       buttonText: 'Join as Artisan',
//       buttonPosition: 'bottom',
//     },
//   ];

//   return (
//     <section className="cta-products">
//       <div className="cta-header">
//         <h2>Your Vision, Our Craftsmanship</h2>
//         <p>
//           Choose your path — create custom pieces or shop from our curated
//           collection of ready-made furniture
//         </p>
//         <div className="header-badges">
//           <span className="badge custom-badge">🎨 Custom Orders</span>
//           <span className="badge ready-badge">🛍️ Ready-Made</span>
//           {/* <span className="badge artisan-badge">👥 For Artisans</span> */}
//         </div>
//       </div>

//       <div className="cta-products__content">
//         {ctaCards.map((card, index) => (
//           <Card className="cta-card" key={index}>
//             <div className="cta-card__image-wrapper">
//               <img src={card.image} alt={card.title} className="cta-image" />
//               <div className="cta-card__overlay">
//                 <div className="overlay-content">
//                   <div className="overlay-icon">{card.buttonIcon}</div>
//                   <Card.Title className="overlay-title">
//                     {card.title}
//                   </Card.Title>
//                   <p className="overlay-description">{card.description}</p>

//                   <div className="feature-list">
//                     {card.features.map((feature, idx) => (
//                       <div key={idx} className="feature-item">
//                         <span className="feature-check">✓</span>
//                         <span>{feature}</span>
//                       </div>
//                     ))}
//                   </div>

//                   {/* Button at the bottom */}
//                   <div className="button-container">
//                     <button
//                       className="shop-btn"
//                       onClick={() => handleCTAClick(card.type)}
//                     >
//                       <span className="btn-icon">{card.buttonIcon}</span>
//                       {card.buttonText}
//                       <span className="btn-arrow">→</span>
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Card>
//         ))}
//       </div>

//       {/* Quick Stats Section */}
//       {/* <div className="cta-stats">
//         <div className="stat-item">
//           <div className="stat-number">500+</div>
//           <div className="stat-label">Completed Projects</div>
//         </div>
//         <div className="stat-item">
//           <div className="stat-number">200+</div>
//           <div className="stat-label">Skilled Artisans</div>
//         </div>
//         <div className="stat-item">
//           <div className="stat-number">1000+</div>
//           <div className="stat-label">Happy Customers</div>
//         </div>
//         <div className="stat-item">
//           <div className="stat-number">24/7</div>
//           <div className="stat-label">Customer Support</div>
//         </div>
//       </div> */}

//       {/* Trust Badges */}
//       {/* <div className="trust-badges">
//         <span>🔒 Secure Payments</span>
//         <span>✓ Verified Artisans</span>
//         <span>🚚 Free Delivery Over KSh 5,000</span>
//         <span>💳 M-Pesa & Card Accepted</span>
//       </div> */}
//     </section>
//   );
// };

// export default CallToAction;

// // import { useState, useEffect } from 'react';
// // import '../styles/products.scss';
// // import Card from 'react-bootstrap/Card';
// // import Banner1 from '../assets/banner/banner6.webp';
// // import Banner2 from '../assets/banner/banner7.webp';
// // import { Link, useNavigate } from 'react-router-dom';

// // const CallToAction = () => {
// //   const navigate = useNavigate();
// //   const [isLoggedIn, setIsLoggedIn] = useState(false);
// //   const [userRole, setUserRole] = useState(null);
// //   const [currentMode, setCurrentMode] = useState('custom');

// //   useEffect(() => {
// //     const token = localStorage.getItem('access_token');
// //     const role = localStorage.getItem('role');
// //     const savedMode = localStorage.getItem('user_mode') || 'custom';

// //     setIsLoggedIn(!!token);
// //     setUserRole(role);
// //     setCurrentMode(savedMode);
// //   }, []);

// //   const handleCTAClick = (type) => {
// //     if (!isLoggedIn) {
// //       navigate('/login', { state: { from: type } });
// //       return;
// //     }

// //     if (type === 'custom') {
// //       if (userRole === 'client') {
// //         navigate('/client-dashboard');
// //       } else if (userRole === 'artisan') {
// //         navigate('/artisan-dashboard');
// //       } else {
// //         navigate('/login');
// //       }
// //     } else if (type === 'ready-made') {
// //       navigate('/ready-made-products');
// //     }
// //   };

// //   const ctaCards = [
// //     {
// //       image: Banner1,
// //       title: 'Custom Furniture Design',
// //       description: 'Bring your unique vision to life with personalized designs crafted just for you',
// //       buttonText: 'Start Custom Project',
// //       buttonIcon: '🎨',
// //       type: 'custom',
// //       features: ['Personalized Design', 'Premium Materials', 'Expert Craftsmanship']
// //     },
// //     {
// //       image: Banner2,
// //       title: 'Ready-Made Collection',
// //       description: 'Shop premium furniture available for immediate delivery. Quality pieces, ready when you are.',
// //       buttonText: 'Browse Collection',
// //       buttonIcon: '🛍️',
// //       type: 'ready-made',
// //       features: ['In Stock', 'Fast Delivery', 'Quality Guaranteed']
// //     }
// //   ];

// //   return (
// //     <section className="cta-products">
// //       <div className="cta-header">
// //         <h2>Your Vision, Our Craftsmanship</h2>
// //         <p>Choose your path — create custom pieces or shop from our curated collection of ready-made furniture</p>
// //         <div className="header-badges">
// //           <span className="badge custom-badge">🎨 Custom Orders</span>
// //           <span className="badge ready-badge">🛍️ Ready-Made</span>
// //         </div>
// //       </div>

// //       <div className="cta-products__content">
// //         {ctaCards.map((card, index) => (
// //           <Card className="cta-card" key={index}>
// //             <div className="cta-card__image-wrapper">
// //               <img src={card.image} alt={card.title} className="cta-image" />
// //               <div className="cta-card__overlay">
// //                 <div className="overlay-content">
// //                   <div className="overlay-icon">{card.buttonIcon}</div>
// //                   <Card.Title className="overlay-title">{card.title}</Card.Title>
// //                   <p className="overlay-description">{card.description}</p>

// //                   <div className="feature-list">
// //                     {card.features.map((feature, idx) => (
// //                       <div key={idx} className="feature-item">
// //                         <span className="feature-check">✓</span>
// //                         <span>{feature}</span>
// //                       </div>
// //                     ))}
// //                   </div>

// //                   <div className="button-container">
// //                     <button
// //                       className="shop-btn"
// //                       onClick={() => handleCTAClick(card.type)}
// //                     >
// //                       <span className="btn-icon">{card.buttonIcon}</span>
// //                       {card.buttonText}
// //                       <span className="btn-arrow">→</span>
// //                     </button>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </Card>
// //         ))}
// //       </div>

// //       {/* Quick Stats Section */}
// //       <div className="cta-stats">
// //         <div className="stat-item">
// //           <div className="stat-number">500+</div>
// //           <div className="stat-label">Completed Projects</div>
// //         </div>
// //         <div className="stat-item">
// //           <div className="stat-number">200+</div>
// //           <div className="stat-label">Skilled Artisans</div>
// //         </div>
// //         <div className="stat-item">
// //           <div className="stat-number">1000+</div>
// //           <div className="stat-label">Happy Customers</div>
// //         </div>
// //         <div className="stat-item">
// //           <div className="stat-number">24/7</div>
// //           <div className="stat-label">Customer Support</div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default CallToAction;



// src/components/CallToAction.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaPalette,
  FaStore,
  FaHammer,
  FaArrowRight,
  FaCheck,
  FaStar,
} from 'react-icons/fa';
import '../styles/home.scss';
import Banner1 from '../assets/banner/banner6.webp';
import Banner2 from '../assets/banner/banner7.webp';
import Banner3 from '../assets/banner/banner8.jpg';

const CTA_CARDS = [
  {
    image: Banner1,
    icon: <FaPalette />,
    tag: 'Custom orders',
    title: 'Commission a one-of-a-kind piece',
    description:
      'Bring your unique vision to life. Sketch it, describe it, or share a mood board — our artisans build it exactly to your spec.',
    features: ['Personalised design', 'Premium materials', 'Milestone-tracked'],
    buttonText: 'Start a custom project',
    type: 'custom',
    accent: 'primary',
  },
  {
    image: Banner2,
    icon: <FaStore />,
    tag: 'Ready-made',
    title: 'Shop pieces made and ready to ship',
    description:
      'Browse a curated collection of finished furniture from verified artisans. Quality pieces, in stock, delivered fast.',
    features: ['In stock now', 'Fast delivery', 'Quality guaranteed'],
    buttonText: 'Browse the collection',
    type: 'ready-made',
    accent: 'secondary',
  },
  {
    image: Banner3,
    icon: <FaHammer />,
    tag: 'For artisans',
    title: 'Grow your workshop on Artiza',
    description:
      'Join a network of skilled makers. Get matched with clients, showcase your craft, and build a business you control.',
    features: ['Steady client flow', 'Own your pricing', 'Verified profile'],
    buttonText: 'Join as an artisan',
    type: 'contact',
    accent: 'tertiary',
  },
];

const CallToAction = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    const role = localStorage.getItem('role');
    setIsLoggedIn(!!token);
    setUserRole(role);
  }, []);

  const handleCTAClick = (type) => {
    // Artisan join always goes directly
    if (type === 'contact') {
      navigate('/artisan-join');
      return;
    }

    // Other actions require login
    if (!isLoggedIn) {
      navigate('/login', { state: { from: type } });
      return;
    }

    if (type === 'custom') {
      if (userRole === 'client') navigate('/client-dashboard');
      else if (userRole === 'artisan') navigate('/artisan-dashboard');
      else navigate('/login');
    } else if (type === 'ready-made') {
      navigate('/ready-made-products');
    }
  };

  return (
    <section className="cta-section">
      {/* Decorative background rings */}
      <span className="cta-deco cta-deco-ring" />
      <span className="cta-deco cta-deco-glow" />

      <div className="cta-wrap">
        {/* ============================================
            HEADER
           ============================================ */}
        <header className="cta-head">
          <span className="cta-eyebrow">
            <span className="cta-eyebrow-dot" />
            Ready when you are
          </span>

          <h2 className="cta-title">
            Your vision,
            <br />
            our <em>craftsmanship</em>.
          </h2>

          <p className="cta-sub">
            Choose your path — commission something bespoke, shop our
            ready-made collection, or join as an artisan. Whichever way you
            start, the rest is transparent.
          </p>
        </header>

        {/* ============================================
            CARDS
           ============================================ */}
        <div className="cta-cards">
          {CTA_CARDS.map((card, i) => (
            <article
              key={i}
              className={`cta-card cta-card--${card.accent}`}
            >
              {/* --- Image header --- */}
              <div className="cta-card-media">
                <img src={card.image} alt={card.title} />
                <div className="cta-card-scrim" />
                <span className="cta-card-tag">
                  <span className="cta-card-tag-icon">{card.icon}</span>
                  {card.tag}
                </span>
              </div>

              {/* --- Body --- */}
              <div className="cta-card-body">
                <h3 className="cta-card-title">{card.title}</h3>
                <p className="cta-card-text">{card.description}</p>

                <ul className="cta-card-features">
                  {card.features.map((f, fi) => (
                    <li key={fi}>
                      <span className="feature-check">
                        <FaCheck />
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>

                <button
                  type="button"
                  className="cta-card-btn"
                  onClick={() => handleCTAClick(card.type)}
                >
                  <span className="cta-card-btn-icon">{card.icon}</span>
                  {card.buttonText}
                  <FaArrowRight className="cta-card-btn-arrow" />
                </button>
              </div>
            </article>
          ))}
        </div>

        {/* ============================================
            TRUST STRIP
           ============================================ */}
        {/* <div className="cta-trust">
          <span className="cta-trust-item">
            <FaStar /> 4.8 average rating
          </span>
          <span className="cta-trust-divider" />
          <span className="cta-trust-item">🔒 Secure M-Pesa & card</span>
          <span className="cta-trust-divider" />
          <span className="cta-trust-item">✓ Verified artisans only</span>
          <span className="cta-trust-divider" />
          <span className="cta-trust-item">🚚 Kenya-wide delivery</span>
        </div> */}
      </div>
    </section>
  );
};

export default CallToAction;